import { Box, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

function SelectorGroup({ label, value, options, onChange }) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.75, fontWeight: 800 }}>
        {label}
      </Typography>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={value}
        onChange={(_event, nextValue) => nextValue && onChange(nextValue)}
        aria-label={label}
      >
        {options.map((option) => (
          <ToggleButton key={option.value} value={option.value} aria-label={option.label}>
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}

export default function DatasetSelectors({ selection, onChange }) {
  return (
    <Stack direction={{ xs: 'column', lg: 'row' }} spacing={2.5}>
      <SelectorGroup
        label="Statistical method"
        value={selection.method}
        options={[{ value: 'deseq2', label: 'DESeq2' }, { value: 'wrst', label: 'WRST' }]}
        onChange={(method) => onChange({ ...selection, method })}
      />
      <SelectorGroup
        label="Expression direction"
        value={selection.direction}
        options={[{ value: 'up', label: 'Overexpressed' }, { value: 'down', label: 'Underexpressed' }]}
        onChange={(direction) => onChange({ ...selection, direction })}
      />
      <SelectorGroup
        label="Comparison scope"
        value={selection.scope}
        options={[{ value: 'all', label: 'All tissues' }, { value: 'subset', label: 'Selected tissues' }]}
        onChange={(scope) => onChange({ ...selection, scope })}
      />
    </Stack>
  );
}
